import { useTranslation } from 'react-i18next';
import useSEO from '@/hooks/useSEO';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import VideoCard from '@/components/base/VideoCard';
import { hotVideos, newVideos, videos } from '@/mocks/videos';

const Home = () => {
  const { t } = useTranslation();

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '红桃视频',
    url: 'https://hongtao.video',
    description: t('site.description'),
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hongtao.video/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '红桃视频',
    url: 'https://hongtao.video',
    description: t('site.description'),
  };

  useSEO({
    title: '红桃视频免费在线观看 - 高清无广告畅享平台',
    description: t('site.description') || '',
    keywords: t('seo.keywords') || '',
    canonicalUrl: 'https://hongtao.video',
    ogTitle: '红桃视频免费在线观看 - 高清无广告畅享平台',
    ogDescription: t('site.description') || '',
    ogUrl: 'https://hongtao.video',
    structuredData: [webSiteSchema, organizationSchema],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <HeroBanner />
      <CategoryNav />

      <div className="bg-background-100/50">
        <VideoGrid
          title={t('home.hot')}
          icon="ri-fire-line"
          videos={hotVideos}
          viewAllLink="/category/all"
          viewAllText={t('home.viewAll')}
        />
      </div>

      <VideoGrid
        title={t('home.new')}
        icon="ri-flashlight-line"
        videos={newVideos}
        viewAllLink="/category/all"
        viewAllText={t('home.viewAll')}
      />

      <section className="py-10 md:py-14 bg-background-100/50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center gap-2.5 mb-6">
            <div className="w-1 h-5 rounded-full bg-accent-500" />
            <h2 className="text-lg md:text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('home.all')}
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {videos.map((video) => (
              <div key={video.id}>
                <VideoCard video={video} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;